import React, { Component } from "react";
import { Link } from "react-router-dom";
// import "simple-line-icons/css/simple-line-icons.css";
// import "font-awesome/css/font-awesome.min.css";
// import "ti-icons/css/themify-icons.css";
// import "perfect-scrollbar/dist/perfect-scrollbar.min.js";
import Constant from "../../../Constant.js";

export default class AddQuestion extends Component {
  state = {
    gameTypeList: [],
    questionTypeList: [],
    answerTypeList: [],
    question: {
      question_title: "",
      question_options: []
    },
    question_options: []
  };
  componentDidMount() {
    this.getGameTypeList();
    this.getQuestionTypeList();
    this.getAnswerTypeList();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.question.question_id !== this.props.question.question_id) {
      this.setState({ question: this.props.question });
      var game_type_id = this.props.question.game_type_id;
      var question_type_id = this.props.question.question_type_id;
      var question_title = this.props.question.question_title;
      var correct_feedback = this.props.question.correct_feedback;
      var incorrect_feedback = this.props.question.incorrect_feedback;
      var answer_type_id = this.props.question.answer_type_id;
      var question_options = this.props.question.question_options;

      this.setState({
        game_type_id,
        question_type_id,
        question_title,
        correct_feedback,
        incorrect_feedback,
        answer_type_id,
        question_options
      });
    }
  }

  getGameTypeList = () => {
    var that = this;
    var data = new FormData();

    data.append("language_id", Constant.language_id());
    fetch(Constant.getAPI() + "/gametypelist", {
      method: "post",
      body: data
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.error === "SFD") {
          console.log(json.data);
          this.setState({
            gameTypeList: json.data
          });
        } else {
          this.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  getQuestionTypeList = () => {
    var that = this;
    var data = new FormData();

    data.append("language_id", Constant.language_id());
    fetch(Constant.getAPI() + "/questiontypelist", {
      method: "post",
      body: data
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.error === "SFD") {
          console.log(json.data);
          this.setState({
            questionTypeList: json.data
          });
        } else {
          this.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  getAnswerTypeList = () => {
    var that = this;
    var data = new FormData();

    data.append("language_id", Constant.language_id());
    fetch(Constant.getAPI() + "/answertypelist", {
      method: "post",
      body: data
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.error === "SFD") {
          console.log(json.data);
          this.setState({
            answerTypeList: json.data
          });
        } else {
          this.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  onInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name == "option") {
      var question_options = this.state.question_options;
      for (let i = 0; i < question_options.length; i++) {
        if (i == e.target.id) {
          question_options[i].option_name = e.target.value;
        }
      }
      this.setState({ question_options: question_options });
    }

    // console.log(question);
    setTimeout(() => {
      var question = {};
      question.game_type_id = this.state.game_type_id;
      question.question_type_id = this.state.question_type_id;
      question.question_title = this.state.question_title;
      question.correct_feedback = this.state.correct_feedback;
      question.incorrect_feedback = this.state.incorrect_feedback;
      question.answer_type_id = this.state.answer_type_id;
      question.question_options = this.state.question_options;
      this.props.onEditQuestion(question);
    }, 20);
  };
  render() {
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="row m-0">
          <div class="card-body border-top bg-white">
            <div className="row mt-3">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect2">
                    Select Game Type
                  </label>
                  <select
                    class="form-control"
                    id="exampleFormControlSelect2"
                    onChange={this.onInputChange}
                    name="game_type_id"
                  >
                    {this.state.gameTypeList.map(gameType =>
                      gameType.game_type_id == this.state.game_type_id ? (
                        <option selected value={gameType.game_type_id}>
                          {gameType.game_type_name}
                        </option>
                      ) : (
                        <option value={gameType.game_type_id}>
                          {gameType.game_type_name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect2">Question Type</label>
                  <select
                    class="form-control"
                    id="exampleFormControlSelect2"
                    onChange={this.onInputChange}
                    name="question_type_id"
                  >
                    {this.state.questionTypeList.map(questionType =>
                      questionType.question_type_id ==
                      this.state.question_type_id ? (
                        <option selected value={questionType.question_type_id}>
                          {questionType.type_name}
                        </option>
                      ) : (
                        <option value={questionType.question_type_id}>
                          {questionType.type_name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect2">Question Title</label>
                  <textarea
                    type="text"
                    class="form-control"
                    placeholder="Question Title"
                    aria-label="Username"
                    value={this.state.question_title}
                    name="question_title"
                    onChange={this.onInputChange}
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect2">
                    Correct Feedback
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    placeholder="Correct Feedback"
                    aria-label="Username"
                    value={this.state.correct_feedback}
                    name="correct_feedback"
                    onChange={this.onInputChange}
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect2">
                    Incorrect Feedback
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    placeholder="Incorrect Feedback"
                    aria-label="Username"
                    value={this.state.incorrect_feedback}
                    name="incorrect_feedback"
                    onChange={this.onInputChange}
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="exampleFormControlSelect2"
                    onChange={this.onInputChange}
                    name="question_answer_type_id"
                  >
                    {this.state.answerTypeList.map(answerType =>
                      answerType.question_answer_type_id ==
                      this.state.answer_type_id ? (
                        <option
                          selected
                          value={answerType.question_answer_type_id}
                        >
                          {answerType.type_name}
                        </option>
                      ) : (
                        <option value={answerType.question_answer_type_id}>
                          {answerType.type_name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>

              <div class="col-lg-12">
                <form class="form-inline repeater">
                  {this.state.question_options.map((option, key) => (
                    <div data-repeater-list="group-a">
                      <div data-repeater-item class="d-flex mb-2">
                        <label class="sr-only" for="inlineFormInputGroup2">
                          Add User
                        </label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                        <label for="exampleFormControlSelect2">Answer Type</label>
                          <div class="input-group-prepend">
                            <span class="input-group-text p-2">{key + 1}</span>
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id={key}
                            placeholder="Option"
                            name={`option`}
                            value={option.option_name}
                            onChange={this.onInputChange}
                          />
                        </div>

                        <div class="form-check form-check-flat">
                          <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" />
                          </label>
                        </div>
                        <button
                          data-repeater-delete
                          type="button"
                          class="btn btn-danger btn-sm icon-btn ml-2"
                        >
                          <i
                            class="menu-icon icon-trash"
                            style={{ fontWeight: "bold" }}
                          ></i>
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    data-repeater-create
                    type="button"
                    class="btn btn-info btn-sm icon-btn ml-2 mb-2"
                  >
                    <i class="menu-icon icon-plus"></i>
                  </button>
                </form>
              </div>

              {/* <div class="col-md-7">
                    <div class="form-group">
                      <label>Question Title</label>
                      <textarea
                        class="form-control"
                        rows="5"
                      ></textarea>
                    </div>
                  </div> */}
            </div>

            <button type="submit" class="btn btn-success btn-fw">
              SAVE
            </button>
          </div>
        </div>
      </nav>
    );
  }
}
